// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  font-family:
    "Open Sans",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  background-color: white;
}

.flex {
  display: flex;
}

.flow-column {
  flex-flow: column;
}

.flex-1 {
  flex: 1;
}

.gap-5 {
  row-gap: 5px;
  column-gap: 5px;
}

.gap-8 {
  row-gap: 8px;
  column-gap: 8px;
}

.gap-10 {
  row-gap: 10px;
  column-gap: 10px;
}

.space-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.no-border {
  border-color: transparent;
}

.title {
  font-size: 32px;
  font-weight: 500;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
}

.text-overflow-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default !important;
}

.margin-auto {
  margin: auto;
}

.font-14 {
  font-size: 14px !important;
}

.font-10 {
  font-size: 10px !important;
}

.weight-600 {
  font-weight: 600;
}

.weight-700 {
  font-weight: 700;
}

.weight-400 {
  font-weight: 400;
}

.width-100 {
  width: 100%;
}

.justify-center {
  justify-content: center;
}

.gap-15 {
  row-gap: 15px;
  column-gap: 15px;
}

.gap-25 {
  row-gap: 25px;
  column-gap: 25px;
}

.font-color-primary {
  color: var(--primary-main);
}
`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT;;;;;;;;;;;;yBAYuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["body,\nhtml {\n  margin: 0;\n  font-family:\n    \"Open Sans\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    sans-serif !important;\n  font-size: 14px;\n  font-weight: 400;\n  color: #000000;\n  background-color: white;\n}\n\n.flex {\n  display: flex;\n}\n\n.flow-column {\n  flex-flow: column;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.gap-5 {\n  row-gap: 5px;\n  column-gap: 5px;\n}\n\n.gap-8 {\n  row-gap: 8px;\n  column-gap: 8px;\n}\n\n.gap-10 {\n  row-gap: 10px;\n  column-gap: 10px;\n}\n\n.space-between {\n  justify-content: space-between;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.no-border {\n  border-color: transparent;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 500;\n}\n\n.page-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.text-overflow-ellipsis {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.margin-auto {\n  margin: auto;\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.font-10 {\n  font-size: 10px !important;\n}\n\n.weight-600 {\n  font-weight: 600;\n}\n\n.weight-700 {\n  font-weight: 700;\n}\n\n.weight-400 {\n  font-weight: 400;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.gap-15 {\n  row-gap: 15px;\n  column-gap: 15px;\n}\n\n.gap-25 {\n  row-gap: 25px;\n  column-gap: 25px;\n}\n\n.font-color-primary {\n  color: var(--primary-main);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
